import { observable } from "mobx";
import { ICalc, IEmpresa, IRelatorios, newEmpresa, newIRelatorios } from "../../model";
import { api, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import moment from "moment";
import { decodeUtf8String, downloadBinaryFile, sortBy, toast_error } from "../../utils";
import { data } from "jquery";

export class _RelatorioStore {
  obs = observable({
    open_initial: false as boolean,
    selectedEmpresa: newEmpresa() as IEmpresa,
    modelo: "" as string,
    tipo: "" as string,
    relatorio: [] as any,
    tasks_relatorio: [] as any[],
    length_tasks_relatorio: 0 as number,
    date_start: "" as string,
    date_end: "" as string,
    relatorios: [] as any,
    select_relatorio: newIRelatorios() as IRelatorios,
    columns: [] as any,
    loading: false as boolean,
    open_erros_relatorio: false as boolean,
    open_relatorios_salvos: false as boolean,
    // date1: "" as string,
    // date2: "" as string,
    // selectedPeriodChaves: [] as any[]
  })

  /**
 * Solicita a criação de um novo relatório no backend com base nos parâmetros fornecidos.
 * 
 * A função envia uma requisição `POST` para o endpoint `/relatorios/geral/create`,
 * contendo os parâmetros de configuração do relatório.  
 * 
 * Em caso de sucesso:
 * - Exibe uma notificação de sucesso via `toast`.
 * - Redireciona o usuário para a página `/relatorios`.
 * 
 * Em caso de falha:
 * - Se o backend retornar um erro (`resp.data.erro`), exibe a mensagem correspondente.
 * - Caso ocorra uma exceção na requisição, exibe uma mensagem genérica de erro.
 * 
 * @async
 * @param {any} params Objeto contendo os parâmetros necessários para gerar o relatório.  
 * Recomenda-se definir uma interface específica (`SolicitarRelatorioParams`) para maior clareza e segurança.
 * 
 * @returns {Promise<void>} Retorna uma Promise resolvida após a solicitação e tratamento da resposta.
 */

  async handleSolicitarRelatorio(params: any) {
    try {
      let resp = await apiOperacao("relatorios").post("/relatorios/geral/create", params);

      if (resp.data.ok) {
        toast.success('Relatório Solicitado', {});
        return true;
      } else {
        toast.error(resp.data.erro, {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao solicitar Relatório, tente novamente mais tarde.`);
    }
    return false;
  }

  /**
   * Solicita a criação de um novo relatório no backend com base nos parâmetros fornecidos.
   * 
   * A função envia uma requisição `POST` para o endpoint `/relatorios/integracao/create`,
   * contendo os parâmetros de configuração do relatório.  
   * 
   * Em caso de sucesso:
   * - Exibe uma notificação de sucesso via `toast`.
   * - Redireciona o usuário para a página `/relatorios`.
   * 
   * Em caso de falha:
   * - Se o backend retornar um erro (`resp.data.erro`), exibe a mensagem correspondente.
   * - Caso ocorra uma exceção na requisição, exibe uma mensagem genérica de erro.
   * 
   * @async
   * @param {any} params Objeto contendo os parâmetros necessários para gerar o relatório.  
   * Recomenda-se definir uma interface específica (`SolicitarRelatorioParams`) para maior clareza e segurança.
   * 
   * @returns {Promise<void>} Retorna uma Promise resolvida após a solicitação e tratamento da resposta.
  */

  async handleSolicitarRelatorioIntegracao(params: any) {
    try {
      let resp = await apiOperacao("relatorios").post("/relatorios/integracao/create", params);

      if (resp.data.ok) {
        toast.success('Relatório Solicitado', {});
      } else {
        toast.error(resp.data.erro, {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao solicitar Relatório, tente novamente mais tarde.`);
    }
  }

  /**
 * Busca a lista paginada de relatórios solicitados.
 * 
 * A função envia uma requisição `POST` para o endpoint `/relatorios/geral/index`,
 * informando o número da página (`page`) e um limite fixo de 15 registros por página.
 * 
 * Em caso de sucesso:
 * - Atualiza `tasks_relatorio` com a lista de itens retornados.
 * - Atualiza `length_tasks_relatorio` com a contagem total de registros.
 * 
 * Em caso de falha:
 * - Exibe uma mensagem de erro genérica via `toast`.
 * 
 * @async
 * @param {number} paged Número da página que deve ser carregada.
 * 
 * @returns {Promise<void>} Retorna uma Promise resolvida após a atualização da lista de relatórios.
 */

  async handleTasksPaged(paged: number, cnpj: string, data_inicio: string, data_fim: string, modelo: string, tipo: string) {
    try {
      let data = {
        page: paged,
        limit: 15,
        cnpj: cnpj,
        date_start: data_inicio,
        date_end: data_fim,
        modelo: modelo,
        tipo: tipo
      }
      let resp = await apiOperacao("relatorios").post("/relatorios/geral/index", data);

      this.obs.tasks_relatorio = [];
      this.obs.length_tasks_relatorio = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_relatorio = resp.data.itens
        this.obs.length_tasks_relatorio = resp.data.count
      }
    } catch (ex) {
      toast_error(ex, `Erro ao carregar Relatórios, tente novamente mais tarde.`);
    }
  }

  /**
  * Busca a lista paginada de relatórios solicitados.
  * 
  * A função envia uma requisição `POST` para o endpoint `/relatorios/integracao/index`,
  * informando o número da página (`page`) e um limite fixo de 15 registros por página.
  * 
  * Em caso de sucesso:
  * - Atualiza `tasks_relatorio` com a lista de itens retornados.
  * - Atualiza `length_tasks_relatorio` com a contagem total de registros.
  * 
  * Em caso de falha:
  * - Exibe uma mensagem de erro genérica via `toast`.
  * 
  * @async
  * @param {number} paged Número da página que deve ser carregada.
  * 
  * @returns {Promise<void>} Retorna uma Promise resolvida após a atualização da lista de relatórios.
  */

  async handleTasksPagedIntegracao(paged: number) {
    try {
      let data = {
        page: paged,
        limit: 15
      }
      let resp = await apiOperacao("relatorios").post("/relatorios/integracao/index", data);

      this.obs.tasks_relatorio = [];
      this.obs.length_tasks_relatorio = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_relatorio = resp.data.itens
        this.obs.length_tasks_relatorio = resp.data.count
      }
    } catch (ex) {
      toast_error(ex, `Erro ao carregar Relatórios, tente novamente mais tarde.`);
    }
  }

  /**
  * Busca a lista paginada de relatórios solicitados.
  * 
  * A função envia uma requisição `POST` para o endpoint `/relatorios/integracao/index-chaves-token`,
  * informando o número da página (`page`) e um limite fixo de 15 registros por página.
  * 
  * Em caso de sucesso:
  * - Atualiza `tasks_relatorio` com a lista de itens retornados.
  * - Atualiza `length_tasks_relatorio` com a contagem total de registros.
  * 
  * Em caso de falha:
  * - Exibe uma mensagem de erro genérica via `toast`.
  * 
  * @async
  * @param {number} paged Número da página que deve ser carregada.
  * 
  * @returns {Promise<void>} Retorna uma Promise resolvida após a atualização da lista de relatórios.
  */

  async handleTasksPagedChavesToken(paged: number, cnpj: string, data_inicio: string, data_fim: string, tipo_integracao: string) {

    try {
      let data = {
        page: paged,
        cnpj: cnpj,
        limit: 15,
        data_inicio: data_inicio,
        data_fim: data_fim,
        tipo_integracao: tipo_integracao
      }

      let resp = await apiOperacao("relatorios").post("/relatorios/integracao/index-chaves-token", data);

      this.obs.tasks_relatorio = [];
      this.obs.length_tasks_relatorio = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_relatorio = resp.data.itens
        this.obs.length_tasks_relatorio = resp.data.count
      }

    } catch (ex) {
      toast_error(ex, `Erro ao carregar Relatórios, tente novamente mais tarde.`);
    }

  }

  /**
  * Solicita a geração de um relatório de chaves token para uma integração.
  *
  * Este método monta o payload com os dados informados pelo usuário,
  * formata o período para o padrão esperado pela API e envia uma requisição
  * POST para o endpoint responsável por criar a solicitação do relatório.
  *
  * Em caso de sucesso, exibe uma mensagem positiva ao usuário e retorna `true`.
  * Em caso de falha na resposta da API ou erro na requisição, exibe uma
  * mensagem de erro e retorna `false`.
  *
  * @param cnpj - CNPJ da empresa para a qual o relatório será solicitado.
  * @param periodo - Array contendo a data inicial e a data final do relatório.
  *                  Espera-se que `periodo[0]` seja a data inicial e
  *                  `periodo[1]` seja a data final.
  * @param tipo_integracao - Tipo de integração relacionada ao relatório.
  * @param chaves - Lista de chaves token que serão consideradas na solicitação.
  *                 Caso não seja informado, será enviado um array vazio.
  * @param razao_social - Razão social da empresa.
  *
  * @returns Retorna `true` caso o relatório seja solicitado com sucesso.
  *          Retorna `false` caso ocorra erro na requisição ou a API informe falha.
  */

  async handleSolicitarRelatorioChavesToken(cnpj: string, periodo: string[], tipo_integracao: string, chaves: string[], razao_social: string) {

    try {
      const data = {
        cnpj,
        razao_social,
        data_inicial: moment(periodo[0]).format("YYYY-MM-DD"),
        data_fim: moment(periodo[1]).format("YYYY-MM-DD"),
        tipo_integracao,
        chaves: chaves || [],
      };

      const resp = await apiOperacao("relatorios").post("/relatorios/integracao/create_chaves_token", data);

      if (!resp.data?.ok) {
        toast.error("Não foi possível solicitar o relatório.");
        return false;
      }

      toast.success("Relatório solicitado com sucesso!");

      return true;

    } catch (ex) {
      toast_error(ex, `Erro ao carregar Relatórios, tente novamente mais tarde.`);
    }

    return false;

  }

  /**
 * Salva as configurações ou dados de um relatório no backend.
 * 
 * A função envia uma requisição `POST` para o endpoint `/relatorios/save`,
 * contendo os parâmetros do relatório a ser salvo.
 * 
 * Em caso de sucesso:
 * - Exibe uma mensagem de confirmação via `toast` informando que o relatório foi salvo.
 * 
 * Em caso de falha:
 * - Se o backend retornar uma mensagem de erro (`resp.data.erro`), ela será exibida.
 * - Caso ocorra um erro na requisição, exibe uma mensagem genérica de falha no salvamento.
 * 
 * @async
 * @param {any} params Objeto contendo as informações necessárias para salvar o relatório.  
 * Recomenda-se definir uma interface específica (`SalvarRelatorioParams`) para maior clareza e segurança de tipos.
 * 
 * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de salvamento.
 */

  async handleSaveRelatorio(params: any) {
    try {

      let resp = await apiOperacao("relatorios").post("/relatorios/geral/save", params);

      if (resp.data.ok) {
        toast.success('Relatório Salvado', {});
      } else {
        toast.error(resp.data.erro, {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao salvar Relatório, tente novamente mais tarde.`);
    }
  }

  /**
 * Carrega a lista de relatórios disponíveis a partir do backend.
 * 
 * A função envia uma requisição `GET` para o endpoint `/relatorios/index`
 * e organiza os relatórios recebidos em categorias específicas:
 * - `nfe`: Notas Fiscais Eletrônicas (NF-E)
 * - `cte`: Conhecimentos de Transporte Eletrônicos (CT-E)
 * - `nfce`: Notas Fiscais de Consumidor Eletrônicas (NFC-E)
 * - `nfse`: Notas Fiscais de Serviços Eletrônicas (NFS-E)
 * 
 * Em caso de sucesso:
 * - Atualiza o estado observável `relatorios` com as listas de cada tipo.
 * 
 * Em caso de falha:
 * - Exibe a mensagem de erro retornada pelo backend.
 * - Se houver exceção na requisição, mostra uma mensagem genérica.
 * 
 * @async
 * @returns {Promise<void>} Retorna uma Promise resolvida após a atualização dos relatórios.
 */

  async handleRelatorios() {
    try {

      let resp = await apiOperacao("relatorios").get("/relatorios/geral/index");

      if (resp.data.ok) {
        this.obs.relatorios = {
          nfe: (resp.data.relatorios["NF-E"] || []),
          cte: (resp.data.relatorios["CT-E"] || []),
          nfce: (resp.data.relatorios["NFC-E"] || []),
          nfse: (resp.data.relatorios["NFS-E"] || [])
        }
      } else {
        toast.error(resp.data.erro, {});
      }
    } catch (ex) {
      toast_error(ex, `Erro ao carregar Relatórios salvos, tente novamente mais tarde.`);
    }
  }

  /**
 * Realiza o download de um relatório no formato especificado para a empresa informada.
 * 
 * A função envia uma requisição `POST` para o endpoint `/relatorios/task/download`,
 * passando o `id` do relatório e o `format` desejado (exemplo: `"xlsx"`).
 * O backend retorna o arquivo no formato binário (`blob`), que é convertido e baixado no
 * navegador com o nome `{cnpj}_relatorio.{format}`.
 * 
 * Durante o processo, a propriedade observável `loading` é usada para indicar visualmente
 * que o download está em andamento.
 * 
 * Em caso de sucesso:
 * - O arquivo é baixado automaticamente no formato solicitado.
 * 
 * Em caso de falha:
 * - Exibe a mensagem de erro contida no cabeçalho (`headers.msg`), se presente.
 * - Caso contrário, mostra uma mensagem genérica de erro.
 * 
 * @async
 * @param {string} id Identificador único do relatório a ser baixado.
 * @param {string} cnpj CNPJ da empresa que será usado no nome do arquivo.
 * @param {string} format Formato do arquivo a ser baixado (ex.: `"xlsx"`).
 * 
 * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de download.
 */

  async handleDownloadArquivoRelatorio(id: string, cnpj: string, format: string) {
    this.obs.loading = true

    try {

      let resp = await apiOperacao("relatorios").post(`/relatorios/task/download`, {id: id, format: format}, { responseType: 'blob' });

      if(resp.status == 200){

        const fileName = cnpj + "_relatorio." + format;

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao baixar arquivo, tente novamente mais tarde.`);

    }

    this.obs.loading = false
  }

 /**
 * Exclui um relatório existente no backend com base no seu identificador.
 * 
 * A função envia uma requisição `DELETE` para o endpoint `/relatorios/{id}`,
 * removendo o relatório informado.  
 * 
 * Antes de iniciar a exclusão, fecha o painel de relatórios salvos (`open_relatorios_salvos = false`).
 * 
 * Em caso de sucesso:
 * - Exibe mensagem de confirmação via `toast`.
 * - Limpa a lista atual de relatórios (`relatorios = []`).
 * - Recarrega a lista de relatórios chamando `handleRelatorios()`.
 * 
 * Em caso de falha:
 * - Se o backend retornar uma mensagem de erro (`resp.data.erro`), ela será exibida via `toast`.
 * - Caso ocorra exceção, não exibe mensagem extra (mas poderia ser ajustado para feedback do usuário).
 * 
 * @async
 * @param {string|number} id Identificador único do relatório que será excluído.
 * 
 * @returns {Promise<void>} Retorna uma Promise resolvida após a tentativa de exclusão.
 */
  async handleDelete(id) {
    RelatorioStore.obs.open_relatorios_salvos = false
    try {
      let resp = await apiOperacao("relatorios").delete(`/relatorios/geral/${id}`);
      if (resp.data.ok) {
        toast.success('Relatório Deletado', {});
        RelatorioStore.obs.relatorios = []
        this.handleRelatorios()
      } else {
        toast.error(resp.data.erro, {});
      }
    } catch (ex) { }
  }

  /**
 * Filtra e retorna a lista de cálculos válidos para a data atual.
 * 
 * A função:
 * 1. Obtém a data e hora atuais.
 * 2. Ordena a lista de cálculos pelo campo `nome`.
 * 3. Retorna apenas os cálculos que estejam dentro do intervalo de validade
 *    definido por `valido_de` e `valido_ate`.
 * 
 * Regras de filtragem:
 * - Se ambos `valido_de` e `valido_ate` forem `null`, o cálculo é considerado válido.
 * - Se a data atual estiver entre `valido_de` e `valido_ate`, o cálculo é válido.
 * - Se `valido_de` for `null` e a data atual for anterior ou igual a `valido_ate`, o cálculo é válido.
 * - Se a data atual for posterior ou igual a `valido_de` e `valido_ate` for `null`, o cálculo é válido.
 * 
 * @param {any} calcs Lista de cálculos a serem verificados.
 * @returns {ICalc[]} Lista de cálculos válidos ordenados por `nome`.
 */

  validForDate(calcs: any): ICalc[] {
    let date = moment(new Date()).format()
    return sortBy(calcs, "nome").filter(calc => {
      if (calc.valido_de == null && calc.valido_ate == null) {
        return true;
      }

      if (date >= moment(calc.valido_de).format() && date <= moment(calc.valido_ate).format()) {
        return true;
      }

      if (calc.valido_de == null && date <= moment(calc.valido_ate).format()) {
        return true;
      }

      if (date >= moment(calc.valido_de).format() && calc.valido_ate == null) {
        return true;
      }

      return false;
    });
  }

}

export const RelatorioStore = new _RelatorioStore();
